





















































import { Component, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric, min, max } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';

extend('required', required);
extend('numeric', numeric);
extend('min', min);
extend('max', max);

export interface Address {
    id?: string;
    district: string;
    amphoe: string;
    province: string;
    zipCode: string;
}

@Component({
  components: {
    Autocomplete,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class SenderInfo extends Vue {
    public $refs: {
      inputPostalCode: HTMLFormElement,
    };
    private errors = [];
    private valid = '';
    private submitted = false;
    private isCreateAddress = true;
    private addressList = [];
    private modalShow = false;
    private selectedAddress = {} as Address;
    private form = {
      id: null,
      name: null,
      tel: null,
      address: null,
    };

    private created() {
      this.getSenderAddress();
    }

    private searchPostalCode(input: any) {
      return new Promise((resolve) => {
        if (input.length < 2) {
          return resolve([]);
        }

        this.$http.get(`/api/zip-code/${input}`).then((response: any) => {
            resolve(response.data);
          }, (err: any) => {
            // error case
          });
        });
    }

    get hasAddress() {
      return Object.entries(this.selectedAddress).length > 0;
    }

    private getResultValue(result: any) {
      return result.district + ' ' + result.amphoe + ' ' + result.province + ' ' + result.zipCode;
    }

    private selectAddress(val: any) {
      this.selectedAddress = val;
    }

    private clearAddress() {
      const key = 'value';
      if (this.getResultValue(this.selectedAddress) === this.$refs.inputPostalCode[key]) {
        this.selectedAddress = {} as Address;
        this.$refs.inputPostalCode.setValue('');
      }
    }

    private blurPostalCode() {
      const key = 'value';
      this.submitted = true;
      if (this.getResultValue(this.selectedAddress) !== this.$refs.inputPostalCode[key]) {
        this.selectedAddress = {} as Address;
        this.$refs.inputPostalCode.setValue('');
      }
    }

    private getSenderAddress() {
      this.$http.get(`/api/address?timestamp=${Date.now()}`).then((response: any) => {
        const data = response.data;
        this.isCreateAddress = false;
        this.form = data;
        this.selectedAddress = {
          province: data.province,
          amphoe: data.amphoe,
          district: data.district,
          zipCode: data.zipCode,
        };
        this.$refs.inputPostalCode.setValue(this.selectedAddress);
      }, (err: any) => {
        // error case
      });
    }

    private senderInfoSubmit() {
      if (Object.entries(this.selectedAddress).length > 0) {
          delete this.selectedAddress.id;
      } else {
        return false;
      }

      if (this.isCreateAddress) {
        const senderData = Object.assign(this.form, this.selectedAddress);
        this.$http.post(`/api/address/sender`, senderData).then((response: any) => {
          Swal.fire({
            allowOutsideClick: false,
            title: 'บันทึกข้อมูลสำเร็จ',
            focusConfirm: false,
            focusCancel: false,
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#ec1b23',
          }).then((result) => {
            if (result.value) {
              this.$router.push({ name: 'receiver' });
            }
          });
        }, (err: any) => {
          Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              focusConfirm: false,
              focusCancel: false,
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#ec1b23',
          }).then((result) => {
              // error case
          });
        });
      } else {
        const senderData = Object.assign(this.form, this.selectedAddress);
        this.$http.put(`/api/address/${this.form.id}`, senderData).then((response: any) => {
          Swal.fire({
            allowOutsideClick: false,
            title: 'บันทึกข้อมูลสำเร็จ',
            focusConfirm: false,
            focusCancel: false,
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#ec1b23',
          }).then((result) => {
            if (result.value) {
              this.$router.push({ name: 'receiver' });
            }
          });
        }, (err: any) => {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then((result) => {
                // error case
            });
        });
      }
    }
}
